import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ServiceProvider } from '../../../providers/ServiceProvider';

/*
  Generated class for the NeedOpotrunity page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-NeedOpotrunity',
    templateUrl: 'NeedOpotrunity.html'
})
export class NeedOpotrunityPage {
    OData: any = {};
    a_Name: string = '';
    Datas: any = [];
    NeedOpps: any = [];
    CompanyIds: any = [];
    AllCompanies: any = [];
    a_Region: any = -1;
    constructor(public navCtrl: NavController, public navParams: NavParams, public serviceProvider: ServiceProvider) { }

    ionViewDidLoad() {
        this.Datas.splice(0, this.Datas.length);
        this.serviceProvider.Get("ISPA_VFfromODataIdToken?odId=47", true).then((result) => {
            let datas: any = result;
            datas.forEach((value, item) => {
                let valuedata: any = value;
                valuedata.DetailedForm.forEach((Detailed_value, index) => {
                    if (Detailed_value.tODataDetailId == 10155) {
                        value.Desc = Detailed_value.cddValue_txt;
                    }
                })
                this.Datas.push(value);
                if (!this.CompanyIds.includes(value.tCustomerId)) {
                    this.CompanyIds.push(value.tCustomerId);
                }
            });
            this.AllCompanies.splice(0, this.AllCompanies.length);
            this.AllCompanies.push({Id : -1 , cuName : 'همه ی کارخانه ها'});
            this.serviceProvider.Get("/IspaCompanyList?tMDId61_Region=null&tDataComboId1=null&cuName=null&Id=", true).then((result) => {
                let companies: any = result;
                companies.forEach((company, index) => {
                    if (this.CompanyIds.includes(company.Id)) {
                        this.AllCompanies.push(company);
                    }
                });
                this.RefreshList()
            });
        });
    }
    RefreshList() {
        this.NeedOpps.splice(0, this.NeedOpps.length);
        console.log(this.Datas);
        this.Datas.forEach((value, index) => {
            if (this.a_Region == -1) {
                if (this.a_Name != '') {
                    if (value.Desc) {
                        if (value.Desc.startsWith(this.a_Name)) {
                            this.NeedOpps.push(value);
                        }
                    }
                }
                else {
                    this.NeedOpps.push(value);
                }
            }
            else {
                if (value.tCustomerId == this.a_Region) {
                    if (this.a_Name != '') {
                        if (value.Desc) {
                            if (value.Desc.startsWith(this.a_Name)) {
                                this.NeedOpps.push(value);
                            }
                        }
                    }
                    else {
                        this.NeedOpps.push(value);
                    }
                }
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/atlas/NeedOpotrunity/NeedOpotrunity.ts